// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"expand-horizontal"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M2.5 5V19M21.5 5V19M17.25 12H6.75M15 15.5L18.5 12L15 8.50001M9 8.50001L5.5 12L9 15.5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ExpandHorizontalIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'expand-horizontal',
    ref,
    icon: element,
  },
));

ExpandHorizontalIcon.displayName = 'ExpandHorizontalIcon';

export default ExpandHorizontalIcon;
